import { Paper, Typography, Button, Box } from "@mui/material";
// import MapComponent from "../Map/MapComponent/MapComponent";
import styles from "./ContactUs.module.css";
import football_img from "../../assets/fallback/image7.jpg";
import { LOCATIONS } from "../../config/locations";
const ContactUs = () => {
  // Location data with addresses and contact info
  const locationData = {
    srinagar: {
      name: "Srinagar",
      address: "WHS Sports Hub, Sonwar Bagh, Srinagar, Jammu & Kashmir 190001",
      contact: "+91 97977 33171",
      email: "contact@whssportshub.in",
      coordinates: LOCATIONS.srinagar,
    },
    // baramulla: {
    //   name: "Pattan",
    //   address:
    //     "WHS Sports Hub, SSM College Campus, Pattan, Baramulla, Jammu & Kashmir",
    //   contact: "+91 97977 33171",
    //   email: "contact@whssportshub.in",
    //   coordinates: LOCATIONS.baramulla,
    // },
    jammu: {
      name: "Jammu",
      address: "KC Sports Club, Paloura, Akhnoor Road, Jammu (J&K)",
      contact: "+91 97977 33171",
      email: "contact@whssportshub.in",
      coordinates: LOCATIONS.jammu,
    },
  };

  // Generate Google Maps directions link
  const getDirectionsLink = (location) => {
    const { lat, lng } = location.coordinates;
    return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
  };

  return (
    <div className={styles.mainWrapper}>
      <div className={styles.background}></div>
      <div className="main-wrapper">
        <div className="background">
          <img
            src={football_img}
            alt="Map"
            loading="lazy"
            decoding="async"
            className="background-image-desktop"
            style={{ width: "100%" }}
          />
        </div>
        <div className="white-paper">
          <Paper
            style={{
              width: "88%",
              position: "relative",
              top: "-15px",
              height: "calc(100% + 15px)",
              padding: "20px 32px 20px 32px",
              boxShadow: "0 0 6px 0 rgba(0, 0, 0, 0.09)",
            }}
          >
            <Typography
              variant="h5"
              component="h2"
              style={{ color: "#01245a", marginBottom: "20px" }}
            >
              <strong>Contact Us</strong>
            </Typography>

            <Typography
              variant="body2"
              style={{
                color: "#797979",
                fontSize: "14px",
                marginBottom: "20px",
              }}
            >
              <strong>E-mail:</strong> contact@whssportshub.in
              <br />
              <strong>Contact No.:</strong> +91 97977 33171
            </Typography>
            <div className={styles.socialMedia}>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.facebook.com/WHSSportsHub"
              >
                <div className={styles.facebookIcon} />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href="https://instagram.com/whssportshub?igshid=YmMyMTA2M2Y="
              >
                <div className={styles.instaIcon} />
              </a>
            </div>
            {/* Location Cards */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {Object.entries(locationData).map(([key, location]) => (
                <Box
                  key={key}
                  sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    padding: "16px",
                    backgroundColor: "#fafafa",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  <Typography
                    variant="h6"
                    style={{
                      color: "#01245a",
                      marginBottom: "8px",
                      fontWeight: 600,
                    }}
                  >
                    {location.name}
                  </Typography>

                  <Typography
                    variant="body2"
                    style={{
                      color: "#797979",
                      fontSize: "14px",
                      marginBottom: "12px",
                      lineHeight: 1.5,
                    }}
                  >
                    <strong>Address:</strong> {location.address}
                  </Typography>

                  <Button
                    variant="outlined"
                    size="small"
                    href={getDirectionsLink(location)}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: "#01245a",
                      borderColor: "#01245a",
                      textTransform: "none",
                      fontSize: "12px",
                      padding: "4px 12px",
                      "&:hover": {
                        backgroundColor: "#01245a",
                        color: "#ffffff",
                        borderColor: "#01245a",
                      },
                    }}
                  >
                    📍 Get Directions
                  </Button>
                </Box>
              ))}
            </Box>
          </Paper>
        </div>
      </div>
      <div className={styles.footer}></div>
    </div>
  );
};

export default ContactUs;
